import pythonApiClient from './pythonBaseApi';

/**
 * Servicio para gestión de lectores
 * Maneja todas las operaciones CRUD relacionadas con lectores
 */
export const lectorApi = {
  /**
   * Obtiene todos los lectores con filtros opcionales
   * @param {number|null} idProyecto - ID del proyecto (opcional)
   * @param {number|null} idComedor - ID del comedor (opcional)
   * @param {number|null} idLector - ID del lector específico (opcional)
   * @returns {Promise} - Respuesta de la API
   */
  getAll: (idProyecto = null, idComedor = null, idLector = null) => {
    let endpoint = '/lectores';
    const params = new URLSearchParams();
    
    if (idLector) {
      endpoint = `/lectores/${idLector}`;
      // Usar endpoint de Python (FastAPI)
      return pythonApiClient.get(endpoint);
    } else {
      if (idProyecto) {
        params.append('id_proyecto', idProyecto);
      }
      if (idComedor) {
        params.append('id_comedor', idComedor);
      }
      if (params.toString()) {
        endpoint += `?${params.toString()}`;
      }
      
      // Usar endpoint de Python (FastAPI)
      return pythonApiClient.get(endpoint);
    }
  },

  /**
   * Obtiene un lector por ID
   * @param {number} id - ID del lector
   * @returns {Promise} - Respuesta de la API
   */
  getById: (id) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.get(`/lectores/${id}`);
  },

  /**
   * Crea un nuevo lector
   * @param {Object} data - Datos del lector
   * @param {number} data.id_proyecto - ID del proyecto
   * @param {number} data.id_comedor - ID del comedor
   * @param {string} data.nombre - Nombre del lector
   * @param {boolean} data.activo - Estado del lector (true=activo, false=inactivo)
   * @returns {Promise} - Respuesta de la API
   */
  create: (data) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.post('/lectores', data);
  },

  /**
   * Actualiza un lector existente
   * @param {number} id - ID del lector
   * @param {Object} data - Datos actualizados del lector
   * @returns {Promise} - Respuesta de la API
   */
  update: (id, data) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.put(`/lectores/${id}`, data);
  },

  /**
   * Elimina un lector
   * @param {number} id - ID del lector
   * @returns {Promise} - Respuesta de la API
   */
  delete: (id) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.delete(`/lectores/${id}`);
  },

  /**
   * Obtiene lectores por proyecto
   * @param {number} proyectoId - ID del proyecto
   * @returns {Promise} - Respuesta de la API
   */
  getByProyecto: (proyectoId) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.get(`/lectores?id_proyecto=${proyectoId}`);
  },

  /**
   * Obtiene lectores por comedor
   * @param {number} comedorId - ID del comedor
   * @returns {Promise} - Respuesta de la API
   */
  getByComedor: (comedorId) => {
    // Usar endpoint de Python (FastAPI)
    return pythonApiClient.get(`/lectores?id_comedor=${comedorId}`);
  }
};

export default lectorApi;
